export const BREACH_PRIMARY_CONTACT_TYPE_ID = 2;
export const BREACH_ESCALATION_CONTACT_TYPE_ID = 3;
export const VULNERABILITY_PRIMARY_CONTACT_TYPE_ID = 4;
export const VULNERABILITY_ESCALATION_CONTACT_TYPE_ID = 5;

export const TEMPLATE_DOWNLOAD_SUCCESS_MESSAGE = 'Template Generated Successfully.';
export const VENDOR_CONTACTS_UPLOAD_SUCCESS_MESSAGE = 'File Uploaded Successfully.';
export const VENDOR_CONTACTS_UPLOAD_FAILED_MESSAGE = 'File Upload Failed.';
